/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `dem_file` - dem_file
 * * `equilibrium_infiltration_rate_file` - equilibrium_infiltration_rate_file
 * * `frict_coef_file` - frict_coef_file
 * * `initial_groundwater_level_file` - initial_groundwater_level_file
 * * `initial_waterlevel_file` - initial_waterlevel_file
 * * `groundwater_hydro_connectivity_file` - groundwater_hydro_connectivity_file
 * * `groundwater_impervious_layer_level_file` - groundwater_impervious_layer_level_file
 * * `infiltration_decay_period_file` - infiltration_decay_period_file
 * * `initial_infiltration_rate_file` - initial_infiltration_rate_file
 * * `leakage_file` - leakage_file
 * * `phreatic_storage_capacity_file` - phreatic_storage_capacity_file
 * * `hydraulic_conductivity_file` - hydraulic_conductivity_file
 * * `porosity_file` - porosity_file
 * * `infiltration_rate_file` - infiltration_rate_file
 * * `max_infiltration_capacity_file` - max_infiltration_capacity_file
 * * `interception_file` - interception_file
 * * `vegetation_height_file` - vegetation_height_file
 * * `vegetation_drag_coefficient_file` - vegetation_drag_coefficient_file
 * * `vegetation_stem_count_file` - vegetation_stem_count_file
 * * `vegetation_stem_diameter_file` - vegetation_stem_diameter_file
 * * `initial_groundwater_concentration_file` - initial_groundwater_concentration_file
 * @export
 */
export const RevisionRasterTypeEnum = {
  DEM_FILE: "dem_file",
  EQUILIBRIUM_INFILTRATION_RATE_FILE: "equilibrium_infiltration_rate_file",
  FRICT_COEF_FILE: "frict_coef_file",
  INITIAL_GROUNDWATER_LEVEL_FILE: "initial_groundwater_level_file",
  INITIAL_WATERLEVEL_FILE: "initial_waterlevel_file",
  GROUNDWATER_HYDRO_CONNECTIVITY_FILE: "groundwater_hydro_connectivity_file",
  GROUNDWATER_IMPERVIOUS_LAYER_LEVEL_FILE: "groundwater_impervious_layer_level_file",
  INFILTRATION_DECAY_PERIOD_FILE: "infiltration_decay_period_file",
  INITIAL_INFILTRATION_RATE_FILE: "initial_infiltration_rate_file",
  LEAKAGE_FILE: "leakage_file",
  PHREATIC_STORAGE_CAPACITY_FILE: "phreatic_storage_capacity_file",
  HYDRAULIC_CONDUCTIVITY_FILE: "hydraulic_conductivity_file",
  POROSITY_FILE: "porosity_file",
  INFILTRATION_RATE_FILE: "infiltration_rate_file",
  MAX_INFILTRATION_CAPACITY_FILE: "max_infiltration_capacity_file",
  INTERCEPTION_FILE: "interception_file",
  VEGETATION_HEIGHT_FILE: "vegetation_height_file",
  VEGETATION_DRAG_COEFFICIENT_FILE: "vegetation_drag_coefficient_file",
  VEGETATION_STEM_COUNT_FILE: "vegetation_stem_count_file",
  VEGETATION_STEM_DIAMETER_FILE: "vegetation_stem_diameter_file",
  INITIAL_GROUNDWATER_CONCENTRATION_FILE: "initial_groundwater_concentration_file",
} as const;
export type RevisionRasterTypeEnum =
  (typeof RevisionRasterTypeEnum)[keyof typeof RevisionRasterTypeEnum];

export function instanceOfRevisionRasterTypeEnum(value: any): boolean {
  for (const key in RevisionRasterTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(RevisionRasterTypeEnum, key)) {
      if (RevisionRasterTypeEnum[key as keyof typeof RevisionRasterTypeEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function RevisionRasterTypeEnumFromJSON(json: any): RevisionRasterTypeEnum {
  return RevisionRasterTypeEnumFromJSONTyped(json, false);
}

export function RevisionRasterTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): RevisionRasterTypeEnum {
  return json as RevisionRasterTypeEnum;
}

export function RevisionRasterTypeEnumToJSON(value?: RevisionRasterTypeEnum | null): any {
  return value as any;
}

export function RevisionRasterTypeEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): RevisionRasterTypeEnum {
  return value as RevisionRasterTypeEnum;
}
